import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
} from "antd";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import { getRequest, patchRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import { FilterFilled } from "@ant-design/icons";
import { ReactComponent as RupeesSign } from "../../image/RupeesSign.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import FormItem from "antd/es/form/FormItem";

const SummaryPriceComparativeByDiameter = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const [siteName, setSiteName] = useState([]);
  const [materialName, setMaterialName] = useState([]);
  const [enableInputs, setEnableInputs] = useState(false);
  const { id } = useParams();
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [categoryTree, setCategoryTree] = useState([]);
  const [siteDetails, setSiteDetails] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const formRef = useRef();
  const [checkedVendors, setCheckedVendors] = useState({});
  const [totalAmount, setTotalAmount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [selectedVendorsPerCity, setSelectedVendorsPerCity] = useState({});
  const [isCompleted, setIsCompleted] = useState(false);
  const [state, setState] = useState({
    hide_r0_price: false,
    hide_r1_price: false,
    hide_r_price: false,
    site_id: [],
    material_type_id: [],
  });
  const [apiLoading, setapiloading] = useState(false);
  const [hideInitialBidPrice, sethideInitialBidPrice] = useState(false);
  const [hideR1BidPrice, setHideR1BidPrice] = useState(false);
  const [hideRBidPrice, setHideRBidPrice] = useState(false);
  const [showUnitRateCementR1, setShowUnitRateCementR1] = useState(false);
  const [showUnitRateCementR, setShowUnitRateCementR] = useState(false);
  const [isFinalBidPrice, setIsFinalBidPrice] = useState(false);
  const [showAdditionalCheckboxesFinal, setShowAdditionalCheckboxesFinal] =
    useState(true);
  const [showAdditionalCheckboxes, setShowAdditionalCheckboxes] =
    useState(false);
  const [comparativesRFQ, setComparativesRFQ] = useState([]);
  const [rfqNumber, setRfqNumber] = useState(null);
  const [reasons, setReasons] = useState([
    "Urgent Delivery",
    "Non Availibility of stock",
    "Exploring alternate Supplier",
    "Split of share",
    "Continue Business relation",
    "Assurance of supply",
    "Others",
  ]);
  const [selectedVendorsPerSite, setSelectedVendorsPerSite] = useState({});
  const [selectedVendorTotalAmount, setSelectedVendorTotalAmount] = useState(0);
  const [editTime, setEditTime] = useState(false);
  const [reasonInputs, setReasonInputs] = useState("");
  const [otherReasons, setOtherReasons] = useState({});
  const [isOtherReason, setIsOtherReason] = useState(false);
  const [categoryType, setCategoryType] = useState(null);

  useEffect(() => {
    const getVendorBidRFQ = async () => {
      setapiloading(true);
      try {
        const response = await getRequest(
          `comparative-rfq/${id}/summery-of-price-comparative/`
        );

        if (response.data.data) {
          setEditTime();
          const responseData =
            response?.data?.data?.summery_of_price_comparative;
          const floatId = response?.data?.data?.float_rfq;
          setIsOtherReason(response?.data?.data?.other_reason);

          const tableData =
            response?.data?.data?.purchase_order_city_details?.map(
              (item, index) => {
                let cityId = index;
                return {
                  key: index,
                  floatId: floatId,
                  company: CompanyId,
                  cityName: item.bid_rfq_city_name,
                  cityTotal: item.city_total,
                  comparative: item.purchase_order_site_details.map(
                    (com, ind) => {
                      return {
                        cityId,
                        siteId: com.rfq_site_id,
                        siteName: com.rfq_site_name,
                        siteSubTotal: 0,
                        siteLocations: com.bid_rfq_detail.map(
                          (item1, index) => {
                            return {
                              cityId,
                              cityName: item.bid_rfq_city_name,
                              materialName: item1.bid_material_type_name,
                              bid_material_type_sub_category: item1.bid_material_type_sub_category,
                              quantity: item1.bid_material_quantity,
                              uom: item1.bid_uom,
                              vendorBids: item1.vendor.map((item2, index3) => {
                                if (item2.selected_reason === "Others") {
                                  setOtherReasons((prev) => ({
                                    ...prev,
                                    [`${index3}_${cityId}`]:
                                      item2?.other_reason_text,
                                  }));
                                }

                                // Get all bid_rfq_steel_ids from diameter_details
                                const bidRfqSteelIds =
                                  item2.diameter_details?.map(
                                    (dia) => dia.bid_rfq_steel_id
                                  ) || [];

                                // Check if any diameter is selected
                                const anyDiameterSelected = (
                                  item2.diameter_details || []
                                ).some((dia) => dia.is_selected);
                                return {
                                  cityId,
                                  cityName: item.bid_rfq_city_name,
                                  bidRfqId: bidRfqSteelIds, // Store as array of IDs
                                  vendorName: item2.vendor_name,
                                  diameter_details: item2.diameter_details,
                                  vendorId: item2.vendor_id,
                                  siteTotal: 0,
                                  siteId: com.rfq_site_id,
                                  vendor_checked: anyDiameterSelected,
                                  select_reason:
                                    (item2.diameter_details || []).find(
                                      (dia) => dia.is_selected
                                    )?.selected_reason || null,
                                  comparison_ranking:
                                    (item2.diameter_details || []).find(
                                      (dia) => dia.is_selected
                                    )?.comparison_ranking || null,
                                  other_reason_text:
                                    item2?.other_reason_text || "",
                                };
                              }),
                            };
                          }
                        ),
                      };
                    }
                  ),
                };
              }
            );

          let initialTotal = 0;

          tableData.forEach((city) => {
            city.comparative.forEach((site) => {
              site.siteLocations.forEach((location) => {
                location.vendorBids.forEach((vendorBid) => {
                  if (vendorBid.vendor_checked) {
                    vendorBid.diameter_details.forEach((dia) => {
                      initialTotal += dia.amount_with_gst;
                    });
                  }
                });
              });
            });
          });
          if (response.data.data.is_diameter_wise === false) {
            setCategoryType(true);
          } else {
            setCategoryType(false);
          }
          setSelectedVendorTotalAmount(initialTotal);
          const initialSelectedVendors = {};
          tableData.forEach((city, ind) => {
            city.comparative.forEach((site) => {
              site.siteLocations.forEach((location) => {
                location.vendorBids.forEach((vendorBid) => {
                  if (vendorBid.vendor_checked) {
                    initialSelectedVendors[ind] = vendorBid.vendorId;
                  }
                });
              });
            });
          });
          setSelectedVendorsPerCity(initialSelectedVendors);
          setComparativesRFQ(tableData);
          setRfqNumber(response.data?.data?.rfq_number);
          if (response?.data?.data?.po_approval === true) {
            setIsCompleted(response?.data?.data?.po_approval);
          }
          setapiloading(false);
        } else {
          ErrorNotificationMsg(t("Error in Comparatives"));
          setapiloading(false);
        }
      } catch (error) {
        console.error("Error:", error);
        setapiloading(false);
      }
    };
    getVendorBidRFQ();
  }, [id]);

  const handleCheckboxChange = () => {
    setIsFinalBidPrice(!isFinalBidPrice);
    setShowAdditionalCheckboxesFinal(true);
    setState((prevState) => ({
      ...prevState,
      is_final_bid_price: !isFinalBidPrice,
    }));
  };

  const handleCheckboxhideR1 = () => {
    sethideInitialBidPrice(!hideInitialBidPrice);
  };

  const handleCheckboxhideR = () => {
    setHideR1BidPrice(!hideR1BidPrice);
  };

  const handleCheckboxhideRR = () => {
    setHideRBidPrice(!hideRBidPrice);
  };

  const updateState = async () => {
    // Implementation remains the same
  };

  const handleSiteNameSelectChange = async (value) => {
    const updatedState1 = { ...state, site_id: value };
    setState(updatedState1);
  };

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
    } else {
      updateState();
    }
  }, [state]);

  const handleMaterialSelectChange = async (value) => {
    let updatedState2 = { ...state, material_type_id: value };
    setState(updatedState2);
  };

  const handleLowestChange = (
    totalAmount,
    vendorId,
    isChecked,
    cityId,
    vendorName
  ) => {
    if (isChecked) {
      setSelectedVendorsPerCity((prev) => ({
        ...prev,
        [cityId]: vendorId,
      }));
      setSelectedVendorTotalAmount((prevTotal) => prevTotal + totalAmount);
    } else {
      setSelectedVendorsPerCity((prev) => ({
        ...prev,
        [cityId]: undefined,
      }));
      setSelectedVendorTotalAmount((prevTotal) => prevTotal - totalAmount);
    }

    setComparativesRFQ((prev) =>
      prev.map((city) => {
        if (city.key === cityId) {
          return {
            ...city,
            comparative: city.comparative.map((site) => ({
              ...site,
              siteLocations: site.siteLocations.map((location) => ({
                ...location,
                vendorBids: location.vendorBids.map((vendor) => {
                  if (vendor.vendorId === vendorId) {
                    // Find the selected diameter, or fallback to first
                    const selectedDia =
                      (vendor.diameter_details || []).find(
                        (dia) => dia.is_selected
                      ) ||
                      (vendor.diameter_details && vendor.diameter_details[0]);
                    return {
                      ...vendor,
                      vendor_checked: isChecked,
                      disabled: isChecked
                        ? vendor.vendorId !== vendorId
                        : false,
                      select_reason: isChecked ? vendor.select_reason : null,
                      comparison_ranking: selectedDia
                        ? selectedDia.comparison_ranking
                        : null,
                    };
                  }
                  return {
                    ...vendor,
                    vendor_checked: false,
                    disabled: false,
                    select_reason: null,
                    comparison_ranking: null,
                  };
                }),
              })),
            })),
          };
        }
        return city;
      })
    );
  };

  const handleReasonChange = (value, vendorId, cityId) => {
    setComparativesRFQ((prev) =>
      prev.map((city) => {
        if (city.key === cityId) {
          return {
            ...city,
            comparative: city.comparative.map((site) => ({
              ...site,
              siteLocations: site.siteLocations.map((location) => ({
                ...location,
                vendorBids: location.vendorBids.map((vendor) => {
                  if (vendor.vendorId === vendorId) {
                    // Find the selected diameter, or fallback to first
                    const selectedDia =
                      (vendor.diameter_details || []).find(
                        (dia) => dia.is_selected
                      ) ||
                      (vendor.diameter_details && vendor.diameter_details[0]);
                    return {
                      ...vendor,
                      select_reason: value,
                      comparison_ranking: selectedDia
                        ? selectedDia.comparison_ranking
                        : null,
                    };
                  }
                  return vendor;
                }),
              })),
            })),
          };
        }
        return city;
      })
    );
  };

  const handleOtherReasonChange = (value, vendorId, cityId) => {
    setComparativesRFQ((prev) =>
      prev.map((entry) => ({
        ...entry,
        comparative: entry.comparative.map((comp) => ({
          ...comp,
          siteLocations: comp.siteLocations.map((loc) => ({
            ...loc,
            vendorBids: loc.vendorBids.map((vendor) => {
              if (vendor.vendorId === vendorId && vendor.cityId === cityId) {
                return {
                  ...vendor,
                  other_reason_text: value,
                };
              }
              return vendor;
            }),
          })),
        })),
      }))
    );
  };

  const handleLocalChange = (text, vendorId, cityId) => {
    setOtherReasons((prev) => ({
      ...prev,
      [`${vendorId}_${cityId}`]: text,
    }));
  };

  const handleBlurUpdate = (vendorId, cityId) => {
    const key = `${vendorId}_${cityId}`;
    handleOtherReasonChange(otherReasons[key], vendorId, cityId);
  };

  const vendorNames = [
    ...new Set(
      comparativesRFQ.flatMap((item) =>
        item.comparative.flatMap((comp) =>
          comp.siteLocations.flatMap((location) =>
            location.vendorBids.map((vendor) => vendor.vendorName)
          )
        )
      )
    ),
  ];

  const vendorColumns = vendorNames.flatMap((vendorName, index) => ({
    title: vendorName,
    width: 150,
    className: "thirdth",
    children: [
      {
        title: `Unit Rate`,
        dataIndex: "vendors",
        width: 70,
        align: "right",
        render: (vendors, row) => {
          if (!vendors) return null;
          const vendor = vendors.find((v) => v.vendorName === vendorName);
          if (!vendor || !vendor.diameter_details) return null;

          if (row.siteName === "Ranking") {
            const vendorTotals = row.vendors.map(
              (v) => v.totalAmountWithGST ?? 0
            );
            const minTotal = Math.min(...vendorTotals);
            const maxTotal = Math.max(...vendorTotals);
            const secondMinTotal = Math.min(
              ...vendorTotals.filter((total) => total > minTotal)
            );
            const thirdMinTotal = Math.min(
              ...vendorTotals.filter((total) => total > secondMinTotal)
            );

            const totalAmount = vendor.totalAmountWithGST;
            const cityId = row.ind;
            const selectedVendorForCity = selectedVendorsPerCity[cityId];
            const isChecked = vendor.vendorId === selectedVendorForCity;
            const isDisabled = selectedVendorForCity && !isChecked;

            const cellContent = (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: "8px",
                  paddingRight: "8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    justifyContent: "flex-end",
                  }}
                >
                  {totalAmount === minTotal && (
                    <Tooltip
                      color={"#094E8F"}
                      placement="left"
                      title={
                        <span style={{ color: "#fff" }}>Lowest Price</span>
                      }
                    >
                      <span className="lowest2">L1</span>
                    </Tooltip>
                  )}
                  {totalAmount === secondMinTotal && (
                    <Tooltip
                      color={"#094E8F"}
                      placement="left"
                      title={
                        <span style={{ color: "#fff" }}>
                          Second Lowest Price
                        </span>
                      }
                    >
                      <span className="secondLowest2">L2</span>
                    </Tooltip>
                  )}
                  {totalAmount === thirdMinTotal && (
                    <Tooltip
                      color={"#094E8F"}
                      placement="left"
                      title={
                        <span style={{ color: "#fff" }}>
                          Third Lowest Price
                        </span>
                      }
                    >
                      <span className="thirdLowest2">L3</span>
                    </Tooltip>
                  )}
                  <Checkbox
                    checked={vendor?.vendorChecked}
                    disabled={isCompleted === true ? true : isDisabled}
                    onChange={(e) => {
                      handleLowestChange(
                        vendor.totalAmountWithGST,
                        vendor.vendorId,
                        e.target.checked,
                        cityId,
                        vendor.vendorName
                      );
                    }}
                  />
                </div>
                {vendor.totalAmountWithGST !== minTotal && (
                  <Select
                    style={{ width: "200px" }}
                    showArrow
                    placeholder={"Select Reason"}
                    disabled={
                      isCompleted === true
                        ? true
                        : !isChecked && !vendor?.selectedReason
                    }
                    value={vendor?.selectedReason}
                    onChange={(value) =>
                      handleReasonChange(value, vendor.vendorId, cityId)
                    }
                  >
                    {reasons.map((item, index) => (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                )}
                {vendor?.selectedReason === "Others" && isOtherReason && (
                  <Input
                    style={{ marginTop: 8, width: 200 }}
                    maxLength={30}
                    placeholder="Enter custom reason"
                    value={
                      otherReasons[`${vendor.vendorId}_${vendor.cityId}`] ??
                      vendor.other_reason_text ??
                      ""
                    }
                    onChange={(e) =>
                      handleLocalChange(
                        e.target.value,
                        vendor.vendorId,
                        vendor.cityId
                      )
                    }
                    onBlur={() =>
                      handleBlurUpdate(vendor.vendorId, vendor.cityId)
                    }
                  />
                )}
                {vendor.totalAmountWithGST === minTotal && (
                  <Select
                    style={{ width: "200px", visibility: "hidden" }}
                    showArrow
                    placeholder={"Select Reason"}
                    disabled={
                      isCompleted === true
                        ? true
                        : !isChecked && !vendor?.selectedReason
                    }
                    value={vendor?.selectedReason}
                    onChange={(value) =>
                      handleReasonChange(value, vendor.vendorId, cityId)
                    }
                  >
                    {reasons.map((item, index) => (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                )}
              </div>
            );
            return {
              children: cellContent,
              props: {
                colSpan: 3,
              },
            };
          } else if (
            row.siteName === "Sub-Total" ||
            row.siteName === "City-sub-Total"
          ) {
            return null; // Unit Rate is not displayed for subtotal rows
          } else if (row.diameter && vendor.diameter_details) {
            const diaDetail = vendor.diameter_details.find(
              (dia) => `${dia.diameter_value} MM` === row.diameter
            );
            return diaDetail ? (
              <>
                <RupeesSign style={{ height: "10px", marginTop: "3px" }} />{" "}
                {diaDetail.unit_rate?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                })}
              </>
            ) : null;
          }
          return null;
        },
      },
      {
        title: (
          <>
            <span>Total Amount</span>
            <br />
            <span>Without GST</span>
          </>
        ),
        dataIndex: "vendors",
        width: 100,
        align: "right",
        render: (vendors, row) => {
          if (!vendors) return null;
          const vendor = vendors.find((v) => v.vendorName === vendorName);
          if (!vendor) return null;

          if (row.siteName === "Ranking") {
            return { props: { colSpan: 0 } };
          } else if (row.siteName === "Sub-Total") {
            return (
              <div className="subtotall">
                ₹{" "}
                {vendor.totalAmountWithoutGST?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) ?? 0}
              </div>
            );
          } else if (row.siteName === "City-sub-Total") {
            return (
              <div className="citytotall">
                ₹{" "}
                {vendor.totalAmountWithoutGST?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) ?? 0}
              </div>
            );
          } else if (row.diameter && vendor.diameter_details) {
            const diaDetail = vendor.diameter_details.find(
              (dia) => `${dia.diameter_value} MM` === row.diameter
            );
            return diaDetail ? (
              <div className="normal-field">
                ₹{" "}
                {diaDetail.amount_without_gst?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) ?? 0}
              </div>
            ) : null;
          }
          return null;
        },
      },
      {
        title: (
          <>
            <span>Total Amount</span>
            <br />
            <span>With GST</span>
          </>
        ),
        dataIndex: "vendors",
        width: 80,
        align: "right",
        render: (vendors, row) => {
          if (!vendors) return null;
          const vendor = vendors.find((v) => v.vendorName === vendorName);
          if (!vendor) return null;

          if (row.siteName === "Ranking") {
            return { props: { colSpan: 0 } };
          } else if (row.siteName === "Sub-Total") {
            return (
              <div className="subtotall">
                ₹{" "}
                {vendor.totalAmountWithGST?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) ?? 0}
              </div>
            );
          } else if (row.siteName === "City-sub-Total") {
            return (
              <div className="citytotall">
                ₹{" "}
                {vendor.totalAmountWithGST?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) ?? 0}
              </div>
            );
          } else if (row.diameter && vendor.diameter_details) {
            const diaDetail = vendor.diameter_details.find(
              (dia) => `${dia.diameter_value} MM` === row.diameter
            );
            return diaDetail ? (
              <div className="normal-field">
                ₹{" "}
                {diaDetail.amount_with_gst?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) ?? 0}
              </div>
            ) : null;
          }
          return null;
        },
      },
    ],
  }));

 
  let srCounter = 1;
  const diameterTableData = [];
  comparativesRFQ.forEach((city, cityIdx) => {
    const srNumber = cityIdx + 1;
    let citySubTotalVendors = {};
    let cityTotalWithGST = 0;

    city.comparative.forEach((site, siteIdx) => {
      let siteSubTotalVendors = {};
      let siteTotalWithGST = 0;

      site.siteLocations.forEach((material, matIdx) => {
        const diameterSet = new Set();
        material.vendorBids.forEach((vendor) => {
          (vendor.diameter_details || []).forEach((dia) => {
            diameterSet.add(dia.diameter_value);
          });
        });
        const diameters = Array.from(diameterSet).sort((a, b) => a - b);

        diameters.forEach((diameter, diaIdx) => {
        
          const vendors = Array.from(
            new Map(
              material.vendorBids.map((vendor) => [vendor.vendorId, vendor])
            ).values()
          ).map((vendor) => {
            const diaDetail = vendor.diameter_details?.find(
              (dia) => dia.diameter_value === diameter
            );

            return {
              siteId: site.siteId,
              vendorId: vendor.vendorId,
              vendorName: vendor.vendorName,
              cityId: city.key,
              cityName: city.cityName,
              diameter_details: vendor.diameter_details,
              vendorChecked: vendor.vendor_checked,
              selectedReason: vendor.select_reason,
              other_reason_text: vendor.other_reason_text,
              totalAmountWithGST: diaDetail ? diaDetail.amount_with_gst : 0,
            };
          });

          vendors.forEach((vendor) => {
            const diaDetail = vendor.diameter_details?.find(
              (dia) => dia.diameter_value === diameter
            );

            if (!diaDetail) return;

            // Initialize site level
            if (!siteSubTotalVendors[vendor.vendorName]) {
              siteSubTotalVendors[vendor.vendorName] = {
                amount_with_gst: 0,
                amount_without_gst: 0,
              };
            }

            // Initialize city level
            if (!citySubTotalVendors[vendor.vendorName]) {
              citySubTotalVendors[vendor.vendorName] = {
                amount_with_gst: 0,
                amount_without_gst: 0,
              };
            }

            // Add only for this diameter (avoid full reduce() on vendor)
            siteSubTotalVendors[vendor.vendorName].amount_with_gst +=
              diaDetail.amount_with_gst || 0;
            siteSubTotalVendors[vendor.vendorName].amount_without_gst +=
              diaDetail.amount_without_gst || 0;

            citySubTotalVendors[vendor.vendorName].amount_with_gst +=
              diaDetail.amount_with_gst || 0;
            citySubTotalVendors[vendor.vendorName].amount_without_gst +=
              diaDetail.amount_without_gst || 0;
          });

          diameterTableData.push({
            key: `${cityIdx}-${siteIdx}-${matIdx}-${diaIdx}`,
            sr:
              diaIdx === 0 && matIdx === 0 && siteIdx === 0
                ? srNumber.toString()
                : "",
            city:
              diaIdx === 0 && matIdx === 0 && siteIdx === 0
                ? city.cityName
                : "",
            site: diaIdx === 0 && matIdx === 0 ? site.siteName : "",
            grade: diaIdx === 0 ? material.materialName : "",
            bid_material_type_sub_category: material.bid_material_type_sub_category,
            uom: diaIdx === 0 ? material.uom : "",
            diameter: `${diameter} MM`,
            quantity:
              vendors[0]?.diameter_details?.find(
                (dia) => dia.diameter_value === diameter
              )?.diameter_total_quantity || "",
            vendors,
          });
        });
      });
      const allVendorBids = site.siteLocations.flatMap(
        (location) => location.vendorBids
      );
      const siteVendorSubTotals = Object.keys(siteSubTotalVendors)
        .map((vendorName) => {
          const totalAmountWithGST =
            siteSubTotalVendors[vendorName].amount_with_gst;
          const totalAmountWithoutGST =
            siteSubTotalVendors[vendorName].amount_without_gst;
          if (totalAmountWithGST > 0) {
            return {
              vendorId: allVendorBids.find((v) => v.vendorName === vendorName)
                ?.vendorId,
              vendorName,
              totalAmountWithGST,
              totalAmountWithoutGST,
            };
          }
          return null;
        })
        .filter(Boolean);

      if (siteVendorSubTotals.length > 0) {
        diameterTableData.push({
          key: `${cityIdx}-${siteIdx}-SubTotal`,
          siteName: "Sub-Total",
          sr: "",
          city: "",
          site: "Sub Total",
          grade: "",
          uom: "",
          diameter: "",
          quantity: "",
          vendors: siteVendorSubTotals,
        });
      }
    });

    // Add city subtotal only once after all sites for the city
    const cityVendorSubTotals = Object.keys(citySubTotalVendors)
      .map((vendorName) => {
        const totalAmountWithGST =
          citySubTotalVendors[vendorName].amount_with_gst;
        const totalAmountWithoutGST =
          citySubTotalVendors[vendorName].amount_without_gst;
        if (totalAmountWithGST > 0) {
          return {
            vendorId: city.comparative[0].siteLocations[0].vendorBids.find(
              (v) => v.vendorName === vendorName
            )?.vendorId,
            vendorName,
            totalAmountWithGST,
            totalAmountWithoutGST,
          };
        }
        return null;
      })
      .filter(Boolean);

    if (cityVendorSubTotals.length > 0) {
      diameterTableData.push({
        key: `${cityIdx}-CitySubTotal`,
        siteName: "City-sub-Total",
        sr: "",
        city: "",
        site: "City Total",
        grade: "",
        uom: "",
        diameter: "",
        quantity: "",
        vendors: cityVendorSubTotals,
      });
    }

    // Add ranking row
    const cityVendors = {};
    city.comparative.forEach((site) => {
      site.siteLocations.forEach((location) => {
        location.vendorBids.forEach((vendor) => {
          const vendorName = vendor.vendorName;
          const totalAmountWithGST =
            vendor.diameter_details?.reduce(
              (sum, dia) => sum + (dia.amount_with_gst || 0),
              0
            ) || 0;
          const totalAmountWithoutGST =
            vendor.diameter_details?.reduce(
              (sum, dia) => sum + (dia.amount_without_gst || 0),
              0
            ) || 0;

          if (!cityVendors[vendorName]) {
            cityVendors[vendorName] = {
              totalAmountWithGST: 0,
              totalAmountWithoutGST: 0,
              vendorId: vendor.vendorId,
              selectedReason: vendor.select_reason,
              vendorChecked: vendor.vendor_checked,
              other_reason_text: vendor.other_reason_text,
              cityId: city.key,
            };
          }
          cityVendors[vendorName].totalAmountWithGST += totalAmountWithGST;
          cityVendors[vendorName].totalAmountWithoutGST +=
            totalAmountWithoutGST;
        });
      });
    });

    const sortedVendors = Object.entries(cityVendors)
      .filter(([_, data]) => data.cityId === city.key)
      .sort((a, b) => a[1].totalAmountWithGST - b[1].totalAmountWithGST);

    if (sortedVendors.length > 0) {
      diameterTableData.push({
        key: `${cityIdx}-Ranking`,
        siteName: "Ranking",
        ind: cityIdx,
        sr: "",
        city: "",
        site: "",
        grade: "",
        uom: "",
        diameter: "",
        quantity: "",
        vendors: sortedVendors.map(([vendorName, data], rankIndex) => ({
          cityName: city.cityName,
          cityId: data.cityId,
          vendorName,
          vendorId: data.vendorId,
          totalAmountWithGST: data.totalAmountWithGST,
          totalAmountWithoutGST: data.totalAmountWithoutGST,
          selectedReason: data?.selectedReason,
          vendorChecked: data?.vendorChecked,
          rank: `L${rankIndex + 1}`,
          other_reason_text: data?.other_reason_text,
          diameter_details:
            city.comparative[0].siteLocations[0].vendorBids.find(
              (v) => v.vendorName === vendorName
            )?.diameter_details,
        })),
      });
    }
  });

  const columns = [
    {
      title: "Sr.",
      dataIndex: "sr",
      width: 50,
    },
    {
      title: "City",
      dataIndex: "city",
      width: 100,
    },
    {
      title: "Site",
      dataIndex: "site",
      width: 100,
      render: (text, record) => {
        if (record.site === "Sub Total") {
          return <span className="subtotal">{record.site}</span>;
        } else if (record.site === "City Total") {
          return <span className="citytotal">{record.site}</span>;
        } else {
          return <span>{text}</span>;
        }
      },
    },
       {
      title: "Sub category",
      dataIndex: "bid_material_type_sub_category",
      width: 150,
    },
    {
      title: "Grade & Quality",
      dataIndex: "grade",
      width: 150,
    },
    {
      title: "UoM.",
      dataIndex: "uom",
      width: 80,
      align: "center",
    },
    {
      title: "Diameter",
      dataIndex: "diameter",
      width: 100,
      align: "center",
    },
    {
      title: "Qty.",
      dataIndex: "quantity",
      width: 60,
      align: "center",
    },
    ...vendorColumns,
  ];

  const handleOnSubmit = async () => {
    if (comparativesRFQ.length === 0) {
      ErrorNotificationMsg("Please select at least one city");
      return;
    }

    const payload = {
      float_rfq: comparativesRFQ[0]?.floatId,
      company: comparativesRFQ[0]?.company,
      purchase_order_city_details: [],
    };

    let citiesWithVendors = [];

    comparativesRFQ.forEach((cityItem) => {
      const vendorsMap = {};

      cityItem.comparative.forEach((siteItem) => {
        siteItem.siteLocations.forEach((siteLocation) => {
          siteLocation.vendorBids.forEach((vendorBid) => {
            if (vendorBid.vendor_checked) {
              const vendorId = vendorBid.vendorId;
              const siteId = siteItem.siteId;

              if (!vendorsMap[vendorId]) {
                vendorsMap[vendorId] = {
                  vendor: vendorId,
                  comparison_ranking: vendorBid.comparison_ranking,
                  select_reason: vendorBid.select_reason,
                  sitesMap: {},
                };
              }

              const vendorEntry = vendorsMap[vendorId];
              if (!vendorEntry.sitesMap[siteId]) {
                vendorEntry.sitesMap[siteId] = {
                  rfq_site_name: siteId,
                  amount_without_gst: 0,
                  amount_with_gst: 0,
                  bid_rfq_steel_detail: [],
                };
              }

              const siteEntry = vendorEntry.sitesMap[siteId];
              siteEntry.amount_without_gst += vendorBid.diameter_details.reduce(
                (sum, dia) => sum + (dia.amount_without_gst || 0),
                0
              );

              siteEntry.amount_with_gst += vendorBid.diameter_details.reduce(
                (sum, dia) => sum + (dia.amount_with_gst || 0),
                0
              );
              if (Array.isArray(vendorBid.bidRfqId)) {
                siteEntry.bid_rfq_steel_detail.push(...vendorBid.bidRfqId);
              } else if (vendorBid.bidRfqId) {
                siteEntry.bid_rfq_steel_detail.push(vendorBid.bidRfqId);
              }
            }
          });
        });
      });

      const cityVendorEntries = Object.values(vendorsMap).map((vendorEntry) => {
        const entry = {
          vendor: vendorEntry.vendor,
          comparison_ranking: vendorEntry.comparison_ranking,
          select_reason: vendorEntry.select_reason,
          purchase_order_site_details: Object.values(vendorEntry.sitesMap),
        };

        if (vendorEntry.select_reason === "Others") {
          const siteId = Object.keys(vendorEntry.sitesMap)[0];
          const siteLocation = cityItem.comparative
            .flatMap((site) => site.siteLocations)
            .flatMap((location) => location.vendorBids)
            .find(
              (bid) =>
                bid.vendorId === vendorEntry.vendor &&
                bid.siteId === parseInt(siteId)
            );

          if (siteLocation?.other_reason_text) {
            entry.other_reason_text = siteLocation.other_reason_text;
          }
        }

        return entry;
      });

      if (cityVendorEntries.length > 0) {
        payload.purchase_order_city_details.push(...cityVendorEntries);
        citiesWithVendors.push(cityItem.id);
      }
    });

    if (payload.purchase_order_city_details.length === 0) {
      ErrorNotificationMsg("Please select vendor");
      return;
    }

    if (comparativesRFQ.length > citiesWithVendors.length) {
      ErrorNotificationMsg("Please select a vendor for each city");
      return;
    }
    for (const vendorEntry of payload.purchase_order_city_details) {
      if (
        vendorEntry.comparison_ranking !== "L1" &&
        (!vendorEntry.select_reason || vendorEntry.select_reason.trim() === "")
      ) {
        ErrorNotificationMsg("Please select a reason");
        return;
      }
    }

    // for (const city of payload.purchase_order_city_details) {
    //   if (!city.select_reason && city.comparison_ranking !== "L1") {
    //     ErrorNotificationMsg("Please select a reason");
    //     return;
    //   }
    // }

    try {
      setBtnLoading(true);
      const response = await postRequest("po-order/", payload);
      if (response.data.success) {
        categoryType
          ? navigate(`/request-for-quotation/previewandsendapproval/${id}`)
          : navigate(
              `/request-for-quotation/previewandsendapproval-by-diameter/${id}`
            );
        setBtnLoading(false);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  const handleOnSubmitView = async () => {
    try {
      setBtnLoading(true);
      navigate(`/request-for-quotation/previewandsendapproval/${id}`);
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Summary Of Price Comparative Statement</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={`/request-for-quotation/comparatives-by-city/${id}`}>
                  City Wise Comparative
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                Summary Of Price Comparative Statement
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
<div className="stepscontentwrap">
        <div className="stepsContent">
      <section className="grid-sec mt-5">
        <div className="PR-body" style={{padding:'0'}}>
          <h5 className="rfq-number new">
            RFQ Number : <span>{rfqNumber}</span>
          </h5>

          <Spin spinning={apiLoading}>
            <Table
              dataSource={diameterTableData}
              columns={columns}
              pagination={false}
              bordered
              className="comparativecustomtbl"
              scroll={{ x: "auto" }}
            />
            <div className="TotalAMT">
              <label>Proposed Order Value: </label>
              <div
                className="citytotal"
                style={{ width: "140px", textAlign: "end" }}
              >
                ₹{" "}
                {selectedVendorTotalAmount
                  ? selectedVendorTotalAmount.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })
                  : 0}
              </div>
            </div>
          </Spin>
          
        </div>
      </section>
      </div>
      <div className="FormFooter bidftr" style={{padding:'16px  ', margin:'0'}}>
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              label="Previous"
              onClick={() => {
                categoryType
                  ? navigate(
                      `/request-for-quotation/comparatives-by-city/${id}`
                    )
                  : navigate(
                      `/request-for-quotation/comparatives-by-city-by-diameter/${id}`
                    );
              }}
            />
            {isCompleted === false && (
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Submit"
                label="Preview and Send for PO Approval"
                onClick={handleOnSubmit}
                loading={btnLoading}
              />
            )}
            {isCompleted === true && (
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Submit"
                label="Preview PO Approval"
                onClick={handleOnSubmitView}
                loading={btnLoading}
              />
            )}
          </div>
      </div>
    </>
  );
};

export default SummaryPriceComparativeByDiameter;
